// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.interactions.HpApiInteractionsV3Handler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiInteractionsV3Handler_add,
  HpApiInteractionsV3Handler_list,
  HpApiInteractionsV3Handler_list_Path,
  HpApiInteractionsV3Handler_remove,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpUserInteractionRequestDto,
  HpUserInteractionsOrderBy,
  HpUserInteractionsResponseDto,
} from '@zg-rentals/ts-hotpads-api-client';

interface ListParams {
  activeOnly?: boolean;
  interactions?: string;
  orderBy?: HpUserInteractionsOrderBy;
  page?: number;
  pageSize?: number;
}

export interface HpApiInteractionsV3Handler_add_Args {
  postData: HpUserInteractionRequestDto;
}

export type HpApiInteractionsV3Handler_add_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiInteractionsV3Handler_add_Args
>;

/**
 * Add a user interaction (favorite/hide/etc.) for a listing
 */
export const useHpApiInteractionsV3Handler_add = ({
  httpClient,
  ...options
}: Omit<HpApiInteractionsV3Handler_add_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiInteractionsV3Handler_add_Args) =>
      HpApiInteractionsV3Handler_add(args.postData, httpClient),
  });
};

export type HpApiInteractionsV3Handler_list_Options = UseQueryOptions<
  HpApiResponseDto<HpUserInteractionsResponseDto>,
  unknown,
  HpApiResponseDto<HpUserInteractionsResponseDto>,
  readonly [string, ListParams]
>;

const HpApiInteractionsV3Handler_list_GetKey = (getParams: ListParams) =>
  [HpApiInteractionsV3Handler_list_Path, getParams] as const;

export const HpApiInteractionsV3Handler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiInteractionsV3Handler_list_GetKey(getParams),
    queryFn: () => HpApiInteractionsV3Handler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * List the signed-in user's interactions (favorites/hidden/etc.) as listings
 */
export const useHpApiInteractionsV3Handler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<HpApiInteractionsV3Handler_list_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiInteractionsV3Handler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useHpApiInteractionsV3Handler_list.getKey = HpApiInteractionsV3Handler_list_GetKey;

export interface HpApiInteractionsV3Handler_remove_Args {
  postData: HpUserInteractionRequestDto;
}

export type HpApiInteractionsV3Handler_remove_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiInteractionsV3Handler_remove_Args
>;

/**
 * Remove a user interaction for a listing
 */
export const useHpApiInteractionsV3Handler_remove = ({
  httpClient,
  ...options
}: Omit<HpApiInteractionsV3Handler_remove_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiInteractionsV3Handler_remove_Args) =>
      HpApiInteractionsV3Handler_remove(args.postData, httpClient),
  });
};
